import React from 'react';
import { Rocket, Gift, Clock, Heart, Sparkles, Cloud } from 'lucide-react';
export function MaintenancePage() {
  return <div className="fixed inset-0 z-[9999] bg-[#F1F5F9] flex items-center justify-center p-6 overflow-hidden" data-id="element-10917" data-mp="1v31otav2mpvc">
      {/* Subtle decorative accents */}
      <Cloud className="hidden sm:block absolute top-16 left-[12%] w-10 h-10 text-[#CBD5E1] opacity-50" data-id="element-10918" data-mp="244rp766xkz59" />
      <Cloud className="hidden sm:block absolute bottom-24 right-[14%] w-8 h-8 text-[#CBD5E1] opacity-40" data-id="element-10919" data-mp="1gf6vbs98ohh7" />
      <Sparkles className="hidden sm:block absolute top-28 right-[22%] w-5 h-5 text-[#7DD3FC] opacity-60" data-id="element-10920" data-mp="1bgdq0n43vws4" />
      <Sparkles className="hidden sm:block absolute bottom-32 left-[20%] w-4 h-4 text-[#7DD3FC] opacity-50" data-id="element-10921" data-mp="1q5iayc2acf3x" />
      <Sparkles className="hidden sm:block absolute top-1/2 left-[8%] w-3 h-3 text-[#7DD3FC] opacity-40" data-id="element-10922" data-mp="1le04j8hhtmbk" />

      <div className="max-w-xl w-full text-center relative" data-id="element-10923" data-mp="xnnspmj4n5fp">
        {/* Rocket badge */}
        <div className="mb-6 flex justify-center" data-id="element-10924" data-mp="sqe1q2g3alpr">
          <div className="w-24 h-24 rounded-full bg-[#E0F2FE] flex items-center justify-center" data-id="element-10925" data-mp="snrxocseqoca">
            <Rocket className="w-11 h-11 text-[#0EA5E9]" data-id="element-10926" data-mp="lpfp8nybksil" />
          </div>
        </div>

        <h1 className="text-[28px] font-semibold text-[#0F172A] mb-3" data-id="element-10927" data-mp="qoign5ldn083">
          We're building something better
        </h1>
        <p className="text-[15px] text-[#64748B] mb-8 leading-relaxed max-w-md mx-auto" data-id="element-10928" data-mp="zinewa2ubdxn">
          We're rolling out a new experience, and the app is briefly
          unavailable while we put the finishing touches in place.
        </p>

        {/* Two info cards */}
        <div className="bg-white rounded-xl border border-[#E2E8F0] shadow-sm grid grid-cols-1 sm:grid-cols-2 sm:divide-x divide-y sm:divide-y-0 divide-[#E2E8F0]" data-id="element-10929" data-mp="7rr37csinfby">
          <div className="p-6 flex flex-col items-center text-center" data-id="element-10930" data-mp="gt8g6mamn0wf">
            <div className="w-12 h-12 rounded-full bg-[#E0F2FE] flex items-center justify-center mb-3" data-id="element-10931" data-mp="1n8hqypfc4ygu">
              <Gift className="w-6 h-6 text-[#0EA5E9]" data-id="element-10932" data-mp="1s6t2d4la3h16" />
            </div>
            <h2 className="text-[15px] font-semibold text-[#0F172A] mb-1.5" data-id="element-10933" data-mp="1s95irdbe1jc4">
              What's new?
            </h2>
            <p className="text-[13px] text-[#64748B] leading-relaxed" data-id="element-10934" data-mp="3k95g9eshh694">
              New features and improvements to help you run your wine club.
            </p>
          </div>
          <div className="p-6 flex flex-col items-center text-center" data-id="element-10935" data-mp="20wjc72i7e9a">
            <div className="w-12 h-12 rounded-full bg-[#E0F2FE] flex items-center justify-center mb-3" data-id="element-10936" data-mp="3ta3gdlzswtmf">
              <Clock className="w-6 h-6 text-[#0EA5E9]" data-id="element-10937" data-mp="35k900ug9wmxf" />
            </div>
            <h2 className="text-[15px] font-semibold text-[#0F172A] mb-1.5" data-id="element-10938" data-mp="30m7iidyhwvo2">
              Back soon
            </h2>
            <p className="text-[13px] text-[#64748B] leading-relaxed" data-id="element-10939" data-mp="3fb3o84d2xwli">
              We'll be back shortly — thanks for your patience.
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-8 flex items-center justify-center gap-2 text-[#64748B]" data-id="element-10940" data-mp="2mrnb6u3s9wmc">
          <Heart className="w-4 h-4 text-[#0EA5E9]" data-id="element-10941" data-mp="2htvja0352ai5" />
          <span className="text-[13px]" data-id="element-10942" data-mp="xcmbkd2kn8yp">Thanks for being with us.</span>
        </div>
      </div>
    </div>;
}